export default __webpack_public_path__ + "media/images/fancybox/fancy_shadow_ne-5d22db686ff08c268e7d763da4bba0ff.png";